import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {FormGroup, Input, Label} from "reactstrap"

class FilterCheckBox extends Component {
    _handleCheckBox = (e) => {
        const {onChange} = this.props

        if (typeof onChange === 'function') {
            onChange()
        }
    }

    render() {
        const {value, label} = this.props

        return (
            <FormGroup check>
                <Label check>
                    <Input checked={value} onChange={this._handleCheckBox}
                           type="checkbox"/>{' '}
                    {label}
                </Label>
            </FormGroup>
        )
    }
}

FilterCheckBox.propTypes = {
    value: PropTypes.bool,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
}

export default FilterCheckBox
